import { Navigate } from "react-router-dom";
import { useTenantAuth } from "../context/TeanantAuthProvider";

/**
 * Map of role slugs to their dashboard routes
 */
export const ROLE_DASHBOARDS = {
  teacher: "/teacher/dashboard",
  "school-admin": "/school-admin/dashboard",
  student: "/student/start-your-quest",
  "organization-admin": "/organization/dashboard",
  parent: "/school-parent/dashboard",
  principal: "/school-admin/dashboard",
  assistant: "/school-admin/dashboard",
  accounts: "/school-admin/dashboard",
  viewer: "/school-admin/dashboard",
  "head-master": "/school-admin/dashboard",
};

/**
 * Map of tenantType to all role slugs that are allowed access.
 * This handles cases where multiple roles share the same dashboard/routes.
 */
const ROLE_ACCESS_MAP = {
  "school-admin": ["school-admin", "assistant", "accounts", "principal", "viewer", "head-master"],
  "school-parent": ["parent", "school-parent"],
  "teacher": ["teacher"],
  student: ["student"],
  "organization-admin": ["organization-admin"],
};

const TenantProtectedRoutes = ({ children, tenantType }) => {
  const { currentUser, loading } = useTenantAuth();

  if (loading || currentUser === undefined) {
    return <div>Loading...</div>;
  }

  if (currentUser === null) {
    return <Navigate to="/login" replace />;
  }

  // Check if the user's role is allowed for this tenantType
  const allowedRoles = ROLE_ACCESS_MAP[tenantType] ?? [tenantType];
  if (allowedRoles.includes(currentUser?.role_slug)) {
    return children;
  }

  // Redirect to the user's own dashboard based on their actual role
  const userDashboard = ROLE_DASHBOARDS[currentUser?.role_slug];
  if (userDashboard) {
    return <Navigate to={userDashboard} replace />;
  }

  return <Navigate to="/login" replace />;
};

export default TenantProtectedRoutes;
